/* @ngInject */
class Dashboard {
	constructor($auth, localStorageService, $q, $http) {
		this.$auth               = $auth;
		this.localStorageService = localStorageService;
		this.$q                  = $q;
		this.$http               = $http;

		this.user = localStorageService.get('user');
	}

	getDashboard() {
		let deferred = this.$q.defer();

		this.$http
		    .get(`${process.env.API_ENDPOINT}dashboard`)
		    .then((response) => {
			    deferred.resolve(response.data);
		    }, () => {
			    this.logout();

			    deferred.reject();
		    });

		return deferred.promise;
	}
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/js/services/dashboard/index.js